module.exports = __webpack_public_path__ + "img/SPteacher.40a9a45b.png";